<template>
  <qx-card-form :title="title">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
      v-if="baseForm.form.length !== 0"
    />
  </qx-card-form>
</template>

<script>
export default {
  props: {
    title: {
      default: '',
    },
    formName: {
      default: '',
    },
  },
  data () {
    return {
      originData: [],
      baseForm: {
        form: [
          // {
          //   label: '客户状态',
          //   value: 'state',
          //   type: 'select',
          // },
        ],
        rules: {
        },
      },
    };
  },
  methods: {

    async sub () {
      const allFormName = ['order', 'driver', 'member'];
      const data = await this.cacheData();
      const result = {};
      data[this.formName].forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          result[`payFeeLimitSecCfgs_${allFormName.indexOf(this.formName)}_${index}.${key}`] = item[key];
        });
      });
      result[`secNumArray_${allFormName.indexOf(this.formName)}`] = this.originData.length;
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      this.originData.forEach((item, index) => {
        item.valueBig = res[String(index)];
      });
      return {
        [this.formName]: this.originData,
      };
    },
    async init (data = {}) {
      this.originData = data[this.formName];
      this.renderForm();
    },
    renderForm () {
      this.baseForm.form = [];
      this.originData.forEach((item, index) => {
        let remark = '';
        switch (this.formName) {
          case 'order':
            switch (index) {
              case 0:
                remark = '如果运费超过此上限，系统不允许开单。';
                break;
              case 1:
                remark = '在新增异常时对承运方赔钱，如果金额超过此上限，系统不允许提交。';
                break;
              case 2:
                remark = '新增异常时对发货方赔钱，如果金额超过此上限，系统不允许提交。';
                break;
              case 3:
                remark = '如果司机借支金额超过此上限，系统不允许借支。';
                break;
              default:
                break;
            }
            break;
          case 'driver':
            switch (index) {
              case 0:
                remark = '在驾驶员档案中设置基本工资时，如果超过此金额，系统不允许提交。';
                break;
              case 1:
                remark = '在驾驶员档案中设置补贴时，如果超过此金额，系统不允许提交。';
                break;
              case 2:
                remark = '在驾驶员工资中，单月工资不能超过此金额，否则工资单无法发送成功。';
                break;
              default:
                break;
            }
            break;
          case 'member':
            switch (index) {
              case 0:
                remark = '司机扫码加油时，如果单次消费超过此金额，系统不允许提交。';
                break;
              case 1:
                remark = '司机扫码加油消费，一天不能超此次数。';
                break;
              case 2:
                remark = '当给非自有车油卡时，系统会自动从尾款中扣除油卡押金金额，待油卡归还后将自动将押金归还到司机账户。';
                break;
              default:
                break;
            }
            break;
          default:
            break;
        }
        this.baseForm.form.push({
          label: item.subTypeName,
          value: String(index),
          type: 'input',
          unit: item.unitName,
          default: item.valueBig,
          remark,
          // remark: index === 0 && this.formName === 'order' ? '如果外请车或者承包车的运费超过运费最大上限设定的值，系统将不允许开单' : '',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
